import React, { useEffect, useState } from "react";
import { Box, Fab, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { SpeedDial, SpeedDialAction } from "@material-ui/lab";
import { ContactSupport, WhatsApp, Mail, Phone, MenuBook } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { selectCleverlynk, selectCompany, selectItemsInCart } from "../../redux/slices/cleverlynkSlice";
import useUserFormFunctions from "../../hooks/useUserFormFunctions";
import { ALIMENTEC_LIST } from "../UserForm/IdentificationField";

interface SocialContacts {
  icon: any;
  name: "WhatsApp" | "Teléfono" | "Correo";
  address: string;
}

const SocialSpeedDials = () => {
  const [open, setOpen] = useState(false);
  const [actions, setActions] = useState<SocialContacts[]>([]);
  const cleverlynk = useSelector(selectCleverlynk);
  const itemsInCart = useSelector(selectItemsInCart);
  const company = useSelector(selectCompany);
  const { isValidEmail } = useUserFormFunctions();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        position: "fixed",
        zIndex: 300,
      },
      speedDial: {
        position: "fixed",
        bottom: itemsInCart.length ? 90 : 20,
        right: theme.spacing(3),
      },
      AlimentecSpeedDial: {
        position: "fixed",
        bottom: itemsInCart.length ? 90 : 30,
        right: theme.spacing(4),
        height: "56px",
      },
    })
  );

  const classes = useStyles(itemsInCart);

  useEffect(() => {
    let addAction: SocialContacts[] = [];

    if (cleverlynk?.phone && cleverlynk?.phone.length > 6)
      addAction.push({ icon: <Phone color="primary" />, name: "Teléfono", address: cleverlynk.phone });

    if (cleverlynk?.whatsapp && cleverlynk.whatsapp.length > 6)
      addAction.push({ icon: <WhatsApp color="primary" />, name: "WhatsApp", address: cleverlynk.whatsapp });
    else if (company?.phones && company?.phones!.length > 0 && company?.phones[0].includes("+573"))
      addAction.push({ icon: <WhatsApp color="primary" />, name: "WhatsApp", address: company.phones[0] });

    if (cleverlynk?.email && isValidEmail(cleverlynk.email))
      addAction.push({ icon: <Mail color="primary" />, name: "Correo", address: cleverlynk.email });
    else if (company?.mails && company?.mails.length > 0)
      addAction.push({ icon: <Mail color="primary" />, name: "Correo", address: company.mails[0] as string });

    setActions(addAction);
  }, [cleverlynk, company?.mails, company?.phones]);

  const onCloseDial = () => {
    setOpen(false);
  };

  const onOpenDial = () => {
    setOpen(true);
  };

  function speedDialActionClick(event: any, action: SocialContacts) {
    event.preventDefault();

    switch (action.name) {
      case "WhatsApp":
        const wspUrl = `https://api.whatsapp.com/send?text=Hola, me gustaría tener más información de la tienda online de ${cleverlynk?.name}&phone=${action.address}`;
        window.open(wspUrl, "_blank");
        break;
      case "Correo":
        window.open(
          `mailto:${action.address}?subject=Información - ${cleverlynk?.name}&body=Hola, me gustaría tener más información de la tienda online de ${cleverlynk?.name}`,
          "_blank"
        );
        break;
      case "Teléfono":
        window.open(`tel:${action.address}`);
    }

    onCloseDial();
  }

  if (!actions.length) return <div></div>;

  if (ALIMENTEC_LIST.includes(cleverlynk?.id ?? "")) {
    return (
      <Box className={classes.root}>
        <Fab
          color="primary"
          className={classes.AlimentecSpeedDial}
          variant="extended"
          onClick={() => (window.location.href = "https://muncheralimentec.clynk.me/")}>
          <MenuBook style={{ marginRight: "16px", paddingLeft: "24px", color: "white" }} />
          <Typography variant="button" style={{ paddingRight: "24px", fontSize: "1rem", color: "white" }}>
            Cambiar de marca
          </Typography>
        </Fab>
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      {actions.length > 1 && (
        <SpeedDial
          ariaLabel="Social Speed Dial"
          className={classes.speedDial}
          icon={<ContactSupport />}
          onClose={onCloseDial}
          onOpen={onOpenDial}
          open={open}
          direction="up">
          {actions.map(action => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              onClick={ev => speedDialActionClick(ev, action)}
            />
          ))}
        </SpeedDial>
      )}
      {actions.length === 1 && (
        <Fab color="primary" className={classes.speedDial} onClick={ev => speedDialActionClick(ev, actions[0])}>
          {actions[0].name === "WhatsApp" && <WhatsApp />}
          {actions[0].name === "Teléfono" && <Phone />}
          {actions[0].name === "Correo" && <Mail />}
        </Fab>
      )}
    </Box>
  );
};

export default SocialSpeedDials;
